import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";

export class ExtensionAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = et(localization);
    }
}

const apiVersion = 1;


export const extension = {
    async extensionInfo() {
        try {
            const response = await restfulApiClient.get("extension_info", apiVersion);
            return response!.data;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new ExtensionAPIConnectorError(err, err.cause);
            }
            throw err;
        }
    },

    async extensionUsePeriod(user_id: string) {
        try {
            const response = await restfulApiClient.get(`extension_use_period/${user_id}`, apiVersion);
            return response!.data;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new ExtensionAPIConnectorError(err, err.cause);
            }
            throw err;
        }
    },

    async applicationForExtension(user_id: string, reason: string) {
        try {
            const response = await restfulApiClient.post(`extension/${user_id}`, apiVersion, {reason: reason});
            return response!.data;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new ExtensionAPIConnectorError(err, err.cause);
            }
            throw err;
        }
    },
}